// Predefined theme palettes used by the user settings color picker.
// Indices are 1-based (matching what we persist in user_settings.primary/secondary_color_index).
// Index 41 is the default for both palettes.

export const DEFAULT_PRIMARY_INDEX = 41;
export const DEFAULT_SECONDARY_INDEX = 41;

// 42 entries (main + dark). MUI computes `light` and `contrastText` automatically.
export const PRIMARY_COLORS = [
    { main: "#d32f2f", dark: "#9a0007" }, //  1
    { main: "#c62828", dark: "#8e0000" }, //  2
    { main: "#d81b60", dark: "#a00037" }, //  3
    { main: "#ad1457", dark: "#78002e" }, //  4
    { main: "#ab47bc", dark: "#790e8b" }, //  5
    { main: "#8e24aa", dark: "#5c007a" }, //  6
    { main: "#6a1b9a", dark: "#38006b" }, //  7
    { main: "#7e57c2", dark: "#4d2c91" }, //  8
    { main: "#5e35b1", dark: "#280680" }, //  9
    { main: "#4527a0", dark: "#000070" }, // 10
    { main: "#5c6bc0", dark: "#26418f" }, // 11
    { main: "#3949ab", dark: "#00227b" }, // 12
    { main: "#283593", dark: "#001064" }, // 13
    { main: "#1976d2", dark: "#004ba0" }, // 14
    { main: "#0277bd", dark: "#004c8c" }, // 15
    { main: "#1565c0", dark: "#003c8f" }, // 16
    { main: "#00838f", dark: "#005662" }, // 17
    { main: "#00796b", dark: "#004c40" }, // 18
    { main: "#00695c", dark: "#003d33" }, // 19
    { main: "#388e3c", dark: "#00600f" }, // 20
    { main: "#2e7d32", dark: "#005005" }, // 21
    { main: "#689f38", dark: "#387002" }, // 22
    { main: "#558b2f", dark: "#255d00" }, // 23
    { main: "#9e9d24", dark: "#6c6f00" }, // 24
    { main: "#d84315", dark: "#9f0000" }, // 25
    { main: "#8d6e63", dark: "#5f4339" }, // 26
    { main: "#6d4c41", dark: "#40241a" }, // 27
    { main: "#4e342e", dark: "#260e04" }, // 28
    { main: "#757575", dark: "#494949" }, // 29
    { main: "#424242", dark: "#1b1b1b" }, // 30
    { main: "#546e7a", dark: "#29434e" }, // 31
    { main: "#2F4F4F", dark: "#052727" }, // 32
    { main: "#224747", dark: "#002020" }, // 33
    { main: "#58b596", dark: "#218568" }, // 34
    { main: "#ce6969", dark: "#993b3e" }, // 35
    { main: "#9400d3", dark: "#5f00a1" }, // 36
    { main: "#00abad", dark: "#007b7e" }, // 37
    { main: "#008000", dark: "#005200" }, // 38
    { main: "#7b68ee", dark: "#443dbb" }, // 39
    { main: "#15854E", dark: "#005725" }, // 40
    { main: "#0d9069", dark: "#00613e" }, // 41 (default)
    { main: "#000000", dark: "#000000" }, // 42
];

// 55 entries (main only). MUI computes `light`/`dark`/`contrastText`.
export const SECONDARY_COLORS = [
    "#00B032", //  1
    "#00B032", //  2
    "#00B00D", //  3
    "#00B007", //  4
    "#5FB000", //  5
    "#6EB000", //  6
    "#94B000", //  7
    "#B0A800", //  8
    "#B0A600", //  9
    "#B0A000", // 10
    "#B08600", // 11
    "#B08700", // 12
    "#B08800", // 13
    "#B06E00", // 14
    "#B06500", // 15
    "#B07100", // 16
    "#B04900", // 17
    "#B03600", // 18
    "#B03600", // 19
    "#B00048", // 20
    "#B00048", // 21
    "#A000B0", // 22
    "#A700B0", // 23
    "#5600B0", // 24
    "#00B081", // 25
    "#00B08D", // 26
    "#00B087", // 27
    "#00B070", // 28
    "#00B032", // 29
    "#00B032", // 30
    "#B06000", // 31
    "#DAA520", // 32
    "#B04100", // 33
    "#B02300", // 34
    "#00B032", // 35
    "#81B000", // 36
    "#B04300", // 37
    "#B00058", // 38
    "#B09A00", // 39
    "#DAA520", // 40
    "#ffd204", // 41 (default)
    "#000000", // 42
    "#d32f2f", // 43
    "#d81b60", // 44
    "#9c27b0", // 45
    "#673ab7", // 46
    "#3f51b5", // 47
    "#1976d2", // 48
    "#0288d1", // 49
    "#00acc1", // 50
    "#009688", // 51
    "#43a047", // 52
    "#689f38", // 53
    "#ff6f00", // 54
    "#e64a19", // 55
];

export const getPrimaryColor = (index) => {
    const idx = Number.isFinite(index) && index >= 1 && index <= PRIMARY_COLORS.length
        ? index - 1
        : DEFAULT_PRIMARY_INDEX - 1;
    return PRIMARY_COLORS[idx];
};

export const getSecondaryColor = (index) => {
    const idx = Number.isFinite(index) && index >= 1 && index <= SECONDARY_COLORS.length
        ? index - 1
        : DEFAULT_SECONDARY_INDEX - 1;
    return SECONDARY_COLORS[idx];
};
